var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96257 4.94479C7.23967 4.67345 7.61207 4.52148 7.9999 4.52148C8.38774 4.52148 8.76013 4.67345 9.03723 4.94479L14.9039 10.7221C15.0398 10.8552 15.1478 11.0141 15.2216 11.1895C15.2953 11.3649 15.3333 11.5532 15.3333 11.7435C15.3333 11.9337 15.2953 12.122 15.2216 12.2974C15.1478 12.4728 15.0398 12.6317 14.9039 12.7648C14.6268 13.0361 14.2544 13.1881 13.8666 13.1881C13.4787 13.1881 13.1063 13.0361 12.8292 12.7648L8.00257 8.01146L3.17057 12.7648C2.89346 13.0361 2.52107 13.1881 2.13323 13.1881C1.7454 13.1881 1.37301 13.0361 1.0959 12.7648C0.959958 12.6317 0.851954 12.4728 0.778219 12.2974C0.704484 12.122 0.666504 11.9337 0.666504 11.7435C0.666504 11.5532 0.704484 11.3649 0.778219 11.1895C0.851954 11.0141 0.959958 10.8552 1.0959 10.7221L6.96257 4.94479V4.94479Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.86d0471a4b691fd3ca5b816dfd416601.svg";
export { ForwardRef as ReactComponent };